import React, { useEffect, useState } from 'react';
import CourseItem from './CourseItem';
import { Link, useParams } from 'react-router-dom';
import ENDPOINT from '../../context/EndPoint';
import Localbase from 'localbase';
import axios from 'axios';
import { useActionsContext } from '../../context/ActionsContext';
import { useDispatch } from 'react-redux';
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext'; // Ensure AuthContext is imported

const CoursesList = () => {
  const dispatch = useDispatch();
  const { user } = useContext(AuthContext); // Ensure user is available
  const { rowsPerPage } = useActionsContext(); // Removed setRowsPerPage if not used
  const { searchquery } = useActionsContext();
  const params = useParams();
  const db = new Localbase('db');

  const [mode, setMode] = useState('all');
  const [courses, setCourses] = useState(null);
  const [initialData, setInitialData] = useState(null); // Changed to null
  const [response, setResponse] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [show, setShow] = useState(false);
  const [currentBatch, setCurrentBatch] = useState(null);
  const [courseUrl, setCourseUrl] = useState(null);
  const [studentsList, setStudentsList] = useState(false);
  const [currentCourse, setCurrentCourse] = useState(null);
  const [editOverview, setEditOverview] = useState(false);
  const [courseId, setCourseId] = useState(null);

  const handleClose = () => setShow(false);

  const addAssignment = (course_url, batch_id) => {
    setCourseUrl(course_url);
    setCurrentBatch(batch_id);
    setShow(true);
  };

  const displayStudents = (course) => {
    setCurrentCourse(course);
    setStudentsList(true);
  };

  const editCourseOverview = ({ courseurl, course_batch, course_id }) => {
    setCurrentBatch(course_batch);
    setCourseUrl(courseurl);
    setCourseId(course_id);
    setEditOverview(true);
  };

  const getCourses = async ({ cat = 'all', query }) => {
    if (!user?.SessionId) {
      dispatch({ 
        type: 'ERROR', 
        payload: 'User session not found. Please log in.'
      });
      return;
    }

    dispatch({ type: 'LOADING' });
    const formData = new FormData();
    formData.append('session', user.SessionId);
    formData.append('mode', cat);
    formData.append('limit', rowsPerPage === 'all' ? 'all' : rowsPerPage);
    if (query) {
      formData.append('query', query); // Support server-side search if implemented
    }

    try {
      const res = await axios.post(
        ENDPOINT + 'admin-get-courses.php', // Updated to match backend filename
        formData,
        { headers: { 'content-type': 'multipart/form-data' } }
      );

      if (res?.data && res.data.status === 'success') {
        dispatch({ type: 'DONE_LOADING' });
        setCourses(res.data.data || []);
        setInitialData(res.data.data || []);
        setResponse(res.data.data || []);
        await db.collection('paths').doc('all_courses').set({
          all_courses: res.data
        });
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: res.data?.message || 'Failed to fetch courses'
        });
      }
    } catch (error) {
      dispatch({ 
        type: 'ERROR', 
        payload: error.message || 'Error fetching courses'
      });
      console.error('Error fetching courses:', error);
    }
  };

  const getOfflineData = async () => {
    try {
      const data = await db.collection('paths').doc('all_courses').get();
      if (data && data.all_courses && data.all_courses.status === 'success') {
        setCourses(data.all_courses.data || []);
        setInitialData(data.all_courses.data || []);
        setResponse(data.all_courses.data || []);
      } else {
        getCourses({ cat: 'all' });
      }
    } catch (error) {
      console.error('Error fetching offline data:', error);
      getCourses({ cat: 'all' });
    }
  };

  useEffect(() => {
    getOfflineData();
  }, []);

  useEffect(() => {
    getCourses({ cat: mode });
  }, [mode, rowsPerPage]);

  const handleSearch = ({ term }) => {
    if (!term) {
      setResponse(initialData || []);
      setSearchTerm('');
      return;
    }
    if (term && initialData) {
      const filteredData = initialData.filter((item) => {
        const lowerTerm = term.toLowerCase();
        return (
          (item.course_id && item.course_id.toLowerCase().includes(lowerTerm)) ||
          (item.course_title && item.course_title.toLowerCase().includes(lowerTerm)) ||
          (item.mode && item.mode.toLowerCase().includes(lowerTerm))
        );
      });
      setResponse(filteredData);
      setSearchTerm(term);
    }
  };

  useEffect(() => {
    handleSearch({ term: searchquery });
  }, [searchquery]);

  return (
    <div className="container-fluid">
      <div className="row g-4 mb-3 d-flex justify-content-end">
        <div className="col-sm-auto">
          <Link to="/add-course" className="btn btn-success">
            <i className="ri-add-line align-bottom me-1" /> Add New Course
          </Link>
        </div>
      </div>
      <div className="row">
        {response ? (
          response.length > 0 ? (
            response.map((item) => (
              <div key={item.course_id} className="col-xxl-4 col-sm-6 project-card">
                <CourseItem item={item} />
              </div>
            ))
          ) : (
            <div className="col-12">No courses found.</div>
          )
        ) : (
          <div className="col-12">Loading...</div>
        )}
      </div>
    </div>
  );
};

export default CoursesList;